import { SvgIcon } from '@crm/shared/ui';

interface IProfileMenuItemProps {
    textContent: string;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
}

export const ProfileMenuItem = ({ textContent, icon }: IProfileMenuItemProps) => (
    <div className="flex w-full cursor-pointer items-center gap-2 px-3.25 py-2.75 text-[13px] hover:bg-smtr-main-gray-50">
        {icon && <SvgIcon icon={icon} size={17} />}
        <span>{textContent}</span>
    </div>
);
